<template>
  <div class="page-charts">
    <div class="header-box">
      <div v-if="tpIsNormal != 0" class="title">
        {{ total === 0 ? "无流量套餐" : planName }}
      </div>

      <img
        v-if="isUpgradeFlag == 1"
        class="order-item-icon"
        src="./img/update_order.png"
        @click="enterUpdateAction()"
      />
    </div>

    <div class="charts-box">
      <div class="charts-left">0</div>
      <div class="charts">
        <div class="box">
          <!-- 左下角拼接半圆 -->
          <div v-if="total !== surplus && total !== 0" class="left-icon-box">
            <div
              class="left-icon"
              :style="{ background: usedProgressBgColor.color }"
            ></div>
          </div>
          <!-- 右下角拼接半圆 -->
          <div class="right-icon-box">
            <div
              class="right-icon"
              :style="{
                background:
                  total === 0 ? '#DCDFE3' : usedProgressBgColor.nousedColor,
              }"
            ></div>
          </div>
          <div class="box-inner">
            <div
              v-if="total !== surplus && total !== 0"
              class="box-item used"
              :style="{ background: usedProgressBgColor.color }"
            >
              <div
                class="white-icon"
                :style="{ background: usedProgressBgColor.color }"
              ></div>
              <div class="box-item-inner"></div>
            </div>
            <div
              class="box-item noused"
              :style="{ background: usedProgressBgColor.nousedColor }"
              :class="{ 'no-plans': total === 0 }"
            >
              <div
                class="white-icon"
                :style="{ background: usedProgressBgColor.nousedColor }"
              ></div>
              <div class="box-item-inner"></div>
            </div>
            <div class="content">
              <div class="value-box">
                <span class="value">
                  <count-to
                    :start-val="0"
                    :end-val="usedPercentage"
                    :duration="duration * 1000"
                  />
                </span>
                <span class="unit">%</span>
              </div>
              <div class="label">已使用流量：{{ used }}G</div>
            </div>
          </div>
        </div>
      </div>
      <div class="charts-right">100</div>
    </div>

    <template>
      <div v-if="surplus === 0 && total > 0" class="tip-box">
        <img class="tip-img" src="./img/tip.png" alt="" />
        <span>流量已用尽，您可购买流量以便继续使用</span>
      </div>
      <div v-else-if="usedPercentage >= trafficWarningValue" class="tip-box">
        <img class="tip-img" src="./img/tip.png" alt="" />
        <span>流量即将用尽，您可购买流量以便继续使用</span>
      </div>
      <div v-else-if="tpIsNormal == 0" class="tip-box">
        <img class="tip-img" src="./img/tip.png" alt="" />
        <span>无可用套餐</span>
      </div>
    </template>
  </div>
</template>

<script>
import CountTo from "vue-count-to";

export default {
  components: { CountTo },
  props: {
    planName: {
      // String 套餐名称
      type: String,
      default: "",
    },
    total: {
      // Number 总流量  值为0 时，暂无套餐
      type: Number,
      default: 0,
    },
    surplus: {
      // Number 剩余流量
      type: Number,
      default: 0,
    },

    percent: {
      // Number 流量比例
      type: Number,
      default: 0,
    },

    tpIsNormal: {
      //当前机具套餐是否正常使用  0-否,1-是
      type: Number,
      default: 1,
    },

    isUpgradeFlag: {
      //是否能套餐升级，0否，1是
      type: Number,
      default: 0,
    },

    trafficWarningValue: {
      // Number 流量使用 X 时展示流量警告提示语  默认80%
      type: Number,
      default: 80,
    },
    usedProgressBgColors: {
      type: Array,
      default: () => [
        // 数组： 根据使用百分比切换进度条颜色
        { color: "#3ADFC1", nousedColor: "#D8F9F3", percentages: [0, 25] }, // 0%-25%
        { color: "#FFAE4C", nousedColor: "#FFEFDB", percentages: [26, 75] },
        { color: "#FF3831", nousedColor: "#FFD7D6", percentages: [76, 100] },
      ],
    },
    duration: {
      // 动画持续时间  单位秒
      type: Number,
      default: 1,
    },
  },
  data() {
    return {};
  },
  computed: {
    used() {
      const total = Math.round(this.total * 100);
      const surplus = Math.round(this.surplus * 100);
      return (total - surplus) / 100;
    },

    // 已使用百分比
    usedPercentage() {
      if (this.total > 0) {
        return this.percent;
      }
      return 0;
    },
    // 计算半圆应该旋转的度数
    usedDeg() {
      let rotation = -170;
      if (this.usedPercentage <= 6) {
        rotation = -170;
      } else {
        rotation = -180 + (this.usedPercentage / 100) * 180;
      }
      rotation = -180 + (this.usedPercentage / 100) * 180;

      return rotation;
    },
    // 根据使用百分比更换进度条背景色
    usedProgressBgColor() {
      return this.usedProgressBgColors.find(
        (item) =>
          this.usedPercentage >= item.percentages[0] &&
          this.usedPercentage <= item.percentages[1]
      );
    },
  },
  watch: {
    usedDeg: {
      handler(val) {
        if (this.usedPercentage > 6) {
          this.$nextTick(() => {
            let circleElement = document.querySelector(".used"); // 获取目标元素
            this.setKeyframesRotate("rotateAnimation", -170, val);
            // 先移除动画
            circleElement.style.animation = "none";
            // 使用 requestAnimationFrame 确保重绘
            requestAnimationFrame(() => {
              // 在下一帧重新应用动画
              requestAnimationFrame(() => {
                circleElement.style.animation = `rotateAnimation ${this.duration}s forwards `;
              });
            });
          });
        }
      },
      immediate: true,
    },
  },
  mounted() {},

  methods: {
    enterUpdateAction() {
      this.$emit("upgrade-click");
    },
    // 动态设置动画角度
    setKeyframesRotate(animationName, fromRotate, toRotate) {
      // 检查是否已经存在同名的 @keyframes 规则
      let styleElement = document.getElementById("dynamicKeyframes");
      if (!styleElement) {
        // 如果不存在，创建新的 <style> 元素
        styleElement = document.createElement("style");
        styleElement.type = "text/css";
        styleElement.id = "dynamicKeyframes"; // 给 <style> 元素添加唯一 ID
        document.head.appendChild(styleElement);
      }

      // 动态生成 @keyframes 规则
      const keyframes = `
        @keyframes ${animationName} {
            from {
                transform: translateX(-50%) rotate(${fromRotate}deg);
            }
            to {
                transform:translateX(-50%) rotate(${toRotate}deg);
            }
        }
    `;

      // 更新 <style> 元素的内容
      styleElement.innerHTML = keyframes;
    },
  },
};
</script>
<style lang="less" scoped>
.page-charts {
  .header-box {
    position: relative; // 作为绝对定位的参考点
    display: flex; // 使用 Flex 布局
    align-items: center; // 垂直居中
    justify-content: center; // 水平居中（使标题居中）
    margin-bottom: 52px; // 将原 title 的下边距移到这里
    width: 100%;

    .title {
      font-weight: 700;
      font-size: 30px;
      color: #000000;
      text-align: center;
    }
    .order-item-icon {
      position: absolute;
      right: -90px;
      top: 50%;
      transform: translateY(-50%);

      display: block;
      width: 116px !important;
      height: 40px !important;
      object-fit: contain;
      cursor: pointer;
      background: var(--primary-color);
      padding: 8px 20px;
      border-radius: 100px;
    }
  }

  .charts-box {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    .charts-left {
      margin-right: 12px;
      margin-bottom: 19px;
      font-size: 24px;
      color: #848992;
    }
    .charts-right {
      margin-left: 12px;
      margin-bottom: 19px;
      font-size: 24px;
      color: #848992;
    }
    .charts {
      width: 428px;
      height: 238px;
      overflow: hidden;

      .box {
        width: 428px;
        height: 214px;
        position: relative;
        border-bottom: 0;
        border-radius: 214px 214px 0 0; /* 上半圆 */
        background: linear-gradient(
          to right,
          var(--subs1-color),
          var(--primary-color)
        ); /* 从左到右的渐变 */
        background-clip: padding-box; /* 确保背景不覆盖边框 */
        padding: 4px 4px 0;
        box-sizing: border-box;
        .left-icon-box {
          position: absolute;
          left: 17px;
          bottom: -24px;
          background: #fff;
          width: 55px;
          height: 24px;
          z-index: 10;
          .left-icon {
            position: absolute;
            left: 2.8px;
            bottom: 0;
            width: 48px;
            height: 24px;
            background: #fc6413;
            border-radius: 0 0 24px 24px;
            z-index: 11;
          }
        }
        .right-icon-box {
          position: absolute;
          right: 20px;
          bottom: -23px;
          background: #fff;
          width: 50px;
          height: 24px;
          z-index: 8;
          .right-icon {
            position: absolute;
            right: 0;
            bottom: 0;
            width: 48px;
            height: 24px;
            border-radius: 0 0 24px 24px;
            z-index: 7;
          }
        }

        .box-inner {
          width: 100%;
          height: 100%;
          background: #fff;
          border-radius: 214px 214px 0 0; /* 上半圆 */
          position: relative;

          .box-item {
            position: absolute;
            left: 50%;
            bottom: 0px;
            width: 388px;
            height: 194px;
            border-radius: 194px 194px 0 0; /* 上半圆 */
            background-clip: padding-box; /* 确保背景不覆盖边框 */
            padding: 48px 48px 0;
            box-sizing: border-box;
            border-bottom: 0;

            &.used {
              background: #fc6413;
              transform-origin: bottom;
              transform: translateX(-50%) rotate(-170deg); // 旋转-170deg - 0deg
              z-index: 9;
              .white-icon {
                position: absolute;
                right: 0;
                bottom: -23px;
                width: 48px;
                height: 24px;
                content: "";
                background: #fc6413;
                border-radius: 0 0 24px 24px;
                &::after {
                  position: absolute;
                  left: 50%;
                  top: 0;
                  width: 28px;
                  height: 28px;
                  background: #fff;
                  transform: translate(-50%, -50%);
                  content: "";
                  border-radius: 50%;
                }
              }
            }
            &.noused {
              // background: linear-gradient(
              //   to right,
              //   #3adfc1,
              //   #1ac7a7
              // ); /* 从左到右的渐变 */
              transform: translateX(-50%); // 旋转-170deg - 0deg

              .white-icon {
                position: absolute;
                left: 0;
                bottom: -24px;
                width: 48px;
                height: 24px;
                content: "";
                // background: #3adfc1;
                border-radius: 0 0 24px 24px;
                &::after {
                  position: absolute;
                  left: 50%;
                  top: 0;
                  width: 28px;
                  height: 28px;
                  background: #fff;
                  transform: translate(-50%, -50%);
                  content: "";
                  border-radius: 50%;
                }
              }
            }
            &.no-plans {
              background: #dcdfe3 !important;
              .white-icon {
                background: #dcdfe3 !important;
              }
            }

            .box-item-inner {
              width: 100%;
              height: 100%;
              background: #fff;
              border-radius: 194px 194px 0 0; /* 上半圆 */
              padding-bottom: 1px;
            }
          }
          .content {
            position: absolute;
            left: 50%;
            bottom: -24px;
            transform: translateX(-50%);
            z-index: 11;
            text-align: center;
            .label {
              font-size: 24px;
              color: #848992;
              margin-top: 16px;
            }
            .value-box {
              display: flex;
              align-items: flex-end;
              justify-content: center;
              .value {
                font-weight: 700;
                font-size: 60px;
                color: #000000;
              }
              .unit {
                font-size: 36px;
              }
            }
          }
        }
      }
    }
  }
  .tip-box {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    color: #ff3831;
    margin-top: 25px;
    .tip-img {
      width: 24px;
      height: 24px;
      margin-right: 8px;
    }
  }
}
</style>
